module.exports = __webpack_public_path__ + "img/placeholder-photo-upload.21c2ae7b.svg";